
<template>
  <div class="container-virtualoffice">
    <!-- ローディング画面 -->
    <div style="position: absolute; z-index: 100; width: 100%; height: 100%; background: white; top: 0; display: flex; align-items: center;" v-if="isVirtualOfficeLoading">
      <Loading/>
    </div>
    <template v-if="virtualOfficeList.length > 0">
      <HeaderMenu
        :isClose="isClose"
        :isConnect="isConnect"
        :isMute="isMute"
        :isBlind="isBlind"
        :isShare="isShare"
        @menu="menu"
        @connectVideo="connectVideo"
        @disconnectVideo="disconnectVideo"
        @shareScreen="shareScreen"
        @audioSwitch="audioSwitch"
        @videoSwitch="videoSwitch"/>
      <div class="main-body">
        <SideMenu
          :isClose="isClose"
          :user="user"
          :userList="userList"
          :chatRooms="chatRooms"
          @site="changeSite"
          @changeModalChatRoom="changeModalChatRoom"
          @openChatRoom="openChatRoom"
          @openChatRoomUser="openChatRoomUser"/>
        <transition name="chat">
        <ChatRoom
          :isVOC="isVOC"
          :user="user"
          :selectChatRoom="selectChatRoom"
          :chatMessages="chatMessages"
          :uriChat="uriChat"
          @sendMessage="sendMessage"
          @cancel="changeOpenChatRoom"
          v-if="isOpenChatRoom"
          />
        </transition>
        <ModalRoom
          :user="user"
          :userList="userList"
          :modalRoomIndex="modalRoomIndex"
          :isShowModal="isModalChatRoom"
          @createChatRoom="createChatRoom"
          @updateChatRoom="updateChatRoom"
          @cancel="changeModalChatRoom"
          v-if="isModalChatRoom"
          />
        <div class="office-body" :class="{'expanded-body': isClose}">
          <div class="main-office" @contextmenu.prevent>
            <Forum v-if="openingForum" />
            <div v-else>
              <OfficeVideo :isConnect="isConnect" :isShare="isShare"/>
              <TooltipSub :message="name" :event="event" :flg="tooltip_flg"/> 
              <svg class="svg" :width="width" :height="height" :viewBox="viewport" @wheel="zoom" @mousemove="touchmove($event)" @mousedown="touchstart($event)" @mouseup="touchend($event)" @mouseleave="touchend($event)"  xmlns="http://www.w3.org/2000/svg">
                <Landscape :width="width" :height="height" :officeType="virtualOfficeList[0].office_type"/>
                <Room :width="width" :height="height" :officeType="virtualOfficeList[0].office_type"/>
                <g @mouseover="toolpop(u,$event,true)" @mouseleave="toolpop(u,$event,false)" v-for="(u, i) in userList">
                  <Member :key="i + '-member-us'" :member="u" :site="isSite" @showProfile="showProfile($event, u)"></Member>
                </g>
                <Member v-for="(cb, i) in cbList"  :key="i + '-member-cb'" :member="cb" @showProfile="showProfile($event, u)"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <ContextMenuVirtualOffice :room="roomName" @openModalSelect="openModalSelect"/>
      <ModalSelectRobots ref="robo"/>
      <ModalShowProfile
        ref="user"
        :users="users"
        :eventGroup="eventGroup"
        @openChatRoomUser="openChatRoomUser"/>
    </template>
    <template v-else>
      <!-- エンゲージメントオフィスが存在しない場合 -->
      <div class="no-office">
        <img src="@/assets/virtualoffice/init.png"/>
        <p style="text-align: left;">
          エンゲージメントオフィスを作成することで、離れた場所にいる勤務者同士が
          「共に仕事」ができるようになります。
          同じ空間にいない人同士が、気軽にコミュニケーションが取れる空間を提供します。
        </p>
        <hr>
        <button @click="initVirtualOffice()" class="button is-primary" v-if="!isNew">
          <span class="mdi mdi-office-building" style="margin-right: 16px;"></span>エンゲージメントオフィスを作成する
        </button>
        <button class="button is-primary" v-if="isNew">
          <span class="mdi mdi-loading mdi-spin" style="margin-right: 16px;"></span>作成中です
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Loading from '@/components/animations/Loading'
import Landscape from '@/views/DashBoard/VirtualOffice/Landscape'
import Room from '@/views/DashBoard/VirtualOffice/Room'
import Member from '@/views/DashBoard/VirtualOffice/Member'
import SideMenu from '@/views/DashBoard/VirtualOffice/SideMenu'
import ChatRoom from '@/components/VirtualOffice/organisms/ChatRoom'
import ModalRoom from '@/components/VirtualOffice/organisms/ModalRoom'
import HeaderMenu from '@/views/DashBoard/VirtualOffice/HeaderMenu'
import OfficeVideo from '@/views/DashBoard/VirtualOffice/OfficeVideo'
import ModalShowProfile from '@/views/DashBoard/VirtualOffice/ModalShowProfile'
import ModalSelectRobots from '@/views/DashBoard/VirtualOffice/ModalSelectRobots'
import ContextMenuVirtualOffice from '@/views/DashBoard/VirtualOffice/ContextMenuVirtualOffice'
import Forum from '@/views/DashBoard/VirtualOffice/Forum/ForumBody'
import TooltipSub from '@/components/atoms/tooltips/TooltipSub.vue'
export default {
  name: 'VirtualOffice',
  componentName: 'VirtualOffice',
  components: {
    Loading,
    Landscape,
    Room,
    Member,
    SideMenu,
    ChatRoom,
    ModalRoom,
    HeaderMenu,
    OfficeVideo,
    ModalShowProfile,
    ModalSelectRobots,
    ContextMenuVirtualOffice,
    Forum,
    TooltipSub
  },
  data () {
    return {
      isNew: false,
      width: 2000,
      height: 1000,
      ratio: 1,
      isMouseDown: false,
      pos: {
        x: 0,
        y: 0
      },
      posDebug: {
        x: 0,
        y: 0
      },
      viewport: '0 0 2000 1000',
      isClose: false,
      isConnect: false,
      isMute: false,
      isBlind: false,
      isShare: false,
      isSite: [],
      selectChatRoom: null,
      isOpenChatRoom: false,
      isModalChatRoom: false,
      modalRoomIndex: 0,
      name:null,
      event:null,
      tooltip_flg:false,      
    }
  },
  computed: {
    ...mapState('auth', ['user', 'users']),
    ...mapState('calendar', ['eventGroup']),
    ...mapState('virtualOffice', ['userList', 'cbList', 'virtualOfficeList', 'isVirtualOfficeLoading', 'chatRooms', 'chatMessages', 'isVOC', 'wsVOC', 'uriChat', 'openingForum']),
    roomName () {
      for (const u of this.userList) {
        if (u.email === this.user.email && u.room) {
          return u.room
        }
      }
      return null
    }
  },
  beforeDestroy () {
    if (this.isConnect) {
      this.$store.dispatch('webRTC/endCall')
      this.isConnect = false
      this.isMute = false
      this.isBlind = false
      this.isShare = false
    }
  },
  created () {
    this.$store.dispatch('virtualOffice/getVirtualOffice', null)
    this.$store.dispatch('virtualOffice/getChatRoom', null)
    this.$store.dispatch('virtualOffice/getForum', null)
  },
  mounted () {
    const uriVO = process.env.WS_ENDPOINT + 'vo/user_list/' + this.user.companyID + '/' + this.user.userHash
    this.$store.dispatch('virtualOffice/connectVirtualOfficeSV', uriVO)
    const con = {'is_connect': true}
    this.$store.dispatch('auth/setUserConnect', con)
  },
  methods: {
    toolpop(u,e,flg){
      this.name=u.name
      this.event=e
      this.tooltip_flg=flg
    },
    zoom (e) {
      var [x, y, w, h] = this.viewport.split(' ').map(v => parseFloat(v))
      if (e.ctrlKey) {
        if (e.deltaY > 0) {
          w = w * 1.01
          h = h * 1.01
        } else {
          w = w * 0.99
          h = h * 0.99
        }
        if (w / this.width > 1.3 || w / this.width < 0.6) {
          alert('申し訳ございませんがこれ以上は拡大縮小を行えません。')
        } else {
          this.ratio = w / this.width
          this.makeViewBox(x, y, w, h)
          localStorage.setItem('ratio___virtualoffice', this.ratio)
        }
        e.preventDefault()
      }
    },
    zoomBtn (d) {
      var [x, y, w, h] = this.viewport.split(' ').map(v => parseFloat(v))
      w = w * d
      h = h * d
      this.viewport = [x, y, w, h].join(' ')
      this.ratio = w / this.width
      localStorage.setItem('ratio___virtualoffice', this.ratio)
    },
    makeViewBox (x, y, w, h) {
      this.viewport = [x, y, w, h].join(' ')
    },
    touchstart (e) {
      this.isMouseDown = true
      console.log("touch start:%d,%d", e.offsetX, e.offsetY);
      this.pos.x = e.offsetX
      this.pos.y = e.offsetY
      document.activeElement.blur()
      e.preventDefault()
    },
    touchmove (e) {
      if (this.isMouseDown) {
        let [x, y, w, h] = this.viewport.split(' ').map(v => parseFloat(v))
        x -= e.offsetX - this.pos.x
        y -= e.offsetY - this.pos.y
        this.posDebug.x = x
        this.posDebug.y = y
        if (x > -100 && x < 900 && y < 400 && y > -400) {
          this.pos.x = e.offsetX
          this.pos.y = e.offsetY
          this.viewport = [x, y, w, h].join(' ')
        }
      }
      e.preventDefault()
    },
    touchend (e) {
      this.isMouseDown = false
      let [x, y, w, h] = this.viewport.split(' ').map(v => parseFloat(v))
      console.log("touch end", x, y)
      e.preventDefault()
    },
    initVirtualOffice () {
      this.isNew = true
      this.$store.dispatch('virtualOffice/initVirtualOffice')
        .then(() => {
          this.isNew = false
        })
    },
    menu () {
      this.isClose = !this.isClose
    },
    connectVideo () {
      if (this.roomName) {
        this.$nextTick(() => {
          let uriParam = this.user.companyID + '_vo_' + this.roomName
          this.isConnect = true
          setTimeout (() => {
            let localVideo = document.getElementById('local_video')
            this.$store.dispatch('webRTC/setVideo', {
              room : uriParam,
              video: localVideo,
              connect: true
            })
          }, 300)
        })
      }
    },
    disconnectVideo () {
      this.$store.dispatch('webRTC/endCall')
      this.isConnect = false
      this.isMute = false
      this.isBlind = false
      this.isShare = false
    },
    shareScreen (flg) {
      this.isShare = flg
      if (this.roomName && this.isShare) {
        this.$nextTick(() => {
          let uriParam = this.user.companyID + '_vo_' + this.roomName
          setTimeout (() => {
            let localVideo = document.getElementById('local_video_share')
            this.$store.dispatch('webRTC/setVideoShare', {
              room : uriParam,
              video: localVideo
            })
          }, 300)
        })
      } else {
        this.$store.dispatch('webRTC/endCallShare')
      }
    },
    audioSwitch (flg) {
      this.isMute = !flg
      this.$store.dispatch('webRTC/setAudioSwitch', flg)
    },
    videoSwitch (flg) {
      this.isBlind = !flg
      this.$store.dispatch('webRTC/setVideoSwitch', flg)
    },
    openModalSelect (type) {
      // typeは求人募集などメニューが増えて来てから
      this.$refs.robo.isCardModalActive = true
    },
    showProfile (event, profile) {
      this.$refs.user.profile = profile
      this.$refs.user.isCardModalActive = true
    },
    changeSite(data) {
      this.isSite = data
      let [x, y, w, h] = this.viewport.split(' ').map(v => parseFloat(v))
      let newX = 0
      let newY = 0
      if (data[0] <= 700) {
        newX = 0
      } else {
        newX = 700
      }
      if (data[1] <= 400) {
        newY = 0
      } else {
        newY = 400
      }
      if (data[2] == true) {
        this.viewport = [newX, newY, w, h].join(' ')
      }
    },
    changeModalChatRoom (flg) {
      this.isModalChatRoom = flg
    },
    createChatRoom (room) {
      this.$store.dispatch('virtualOffice/createChatRoom', room)
    },
    updateChatRoom (room) {
      this.$store.dispatch('virtualOffice/updateChatRoom', room)
    },
    changeOpenChatRoom (flg, room) {
      this.selectChatRoom = room
      this.isOpenChatRoom = flg
    },
    openChatRoom (room) {
      this.$store.dispatch('virtualOffice/getChatRoomMessage',
        room.id
      )
      .then(() => {
        this.changeOpenChatRoom(true, room)
      })
    },
    openChatRoomUser (user) {
      if (user.user_hash != this.user.userHash) {
        let idx = this.$_.findIndex(
          this.chatRooms,
          ((obj) => {
            return this.$_.indexOf(obj.user, user.user_hash) > -1 && obj.type === 2
          })
        )
        if (idx > -1) {
          this.$store.dispatch('virtualOffice/getChatRoomMessage',
            this.chatRooms[idx].id
          ).then(() => {
            this.changeOpenChatRoom(true, this.chatRooms[idx])
          })
        } else {
          this.$store.dispatch('virtualOffice/createChatRoom', {
            type: 2,
            name: null,
            user: [this.user.userHash, user.user_hash],
            company: this.user.companyPK
          }).then((data) => {
              this.changeOpenChatRoom(true, data)
          })
        }
      } else {
        let idx = this.$_.findIndex(
          this.chatRooms,
          ((obj) => {
            return this.$_.indexOf(obj.user, user.user_hash) > -1 && obj.user.length === 1
          })
        )
        if (idx > -1) {
          this.$store.dispatch('virtualOffice/getChatRoomMessage',
            this.chatRooms[idx].id
          ).then(() => {
            this.changeOpenChatRoom(true, this.chatRooms[idx])
          })
        } else {
          this.$store.dispatch('virtualOffice/createChatRoom', {
            type: 2,
            name: null,
            user: [user.user_hash],
            company: this.user.companyPK
          }).then((data) => {
              this.changeOpenChatRoom(true, data)
          })
        }
      }
    },
    sendMessage (data) {
      let sendData = {
        chat_room: this.selectChatRoom.id,
        user: this.user.userHash,
        message: data.message
      }
      this.$store.dispatch('virtualOffice/sendChatRoomSV', sendData)
    }
  },
}
</script>

<style lang="scss" scoped>
.container-virtualoffice {
  padding: 0px !important;
  margin: 0px !important;
  height: 100vh;
  width: 100%;
  background-color: #ffffff;
  overflow: auto;
  position: relative;
}
.svg {
  background-color: #f0d7ea;
  background-image: url("data:image/svg+xml,%3Csvg width='30' height='30' viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 15l15 15H0V15zM15 0l15 15V0H15z' fill='%23c89bca' fill-opacity='0.4' fill-rule='evenodd'/%3E%3C/svg%3E");
}
.main-office {
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
}
.main-body {
  height: calc(100vh - 64px);
  width: 100%;
  display: flex;
  overflow: hidden;
  position: relative;
}
.office-body {
  height: 100%;
  width: calc(100% - 200px);
  overflow: hidden;
}
.expanded-body {
  width: 100%;
}
.no-office {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 50%; min-width: 300px;
  height: 100%;
}
.no-office > img {
  width: 100%;
  height: 300px;
  object-fit: scale-down;
  margin-bottom: 16px;
}

.chat-enter-active, .chat-leave-active {
  position: fixed;
  right: 0;
  transform: translateY(0px);
  transition: 300ms;
}
.chat-enter, .chat-leave-to {
  transform: translateY(100vh);
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/VirtualOffice/VirtualOffice.vue